import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import client from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle, CircleNotch, ArrowRight, Bank } from "@phosphor-icons/react";
import { BrandMark } from "../components/BrandMark";

export default function PayoutReturn() {
  const nav = useNavigate();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get("/connect/status")
      .then((r) => setStatus(r.data))
      .catch(() => setStatus(null))
      .finally(() => setLoading(false));
  }, []);

  const onboarded = status?.onboarded;

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBFAF7] p-6 grain" data-testid="payout-return">
      <div className="max-w-md w-full text-center lux-card rounded-[5px] p-10 fade-up">
        <div className="flex justify-center mb-6"><BrandMark logoSize={34} /></div>
        <div className="flex justify-center mb-4">
          {loading ? <CircleNotch size={48} weight="bold" className="animate-spin text-[#4A0000]" />
            : onboarded ? <CheckCircle size={52} weight="fill" className="text-green-600" />
            : <Bank size={48} weight="duotone" className="text-[#B08D57]" />}
        </div>
        <h1 className="font-display text-3xl mb-2" data-testid="payout-return-title">
          {loading ? "Checking your payout setup…" : onboarded ? "Payouts are set up!" : "Almost there"}
        </h1>
        <p className="text-[#5C5A58] mb-6">
          {loading ? "One moment."
            : onboarded ? "You're all set to receive payouts from Reelty straight to your bank."
            : "Stripe still needs a little more information before you can receive payouts. You can finish anytime from your profile."}
        </p>
        <Button data-testid="payout-return-continue" onClick={() => nav("/")} className="bg-[#4A0000] hover:bg-[#5C1A1A] text-white w-full">
          Back to the hub <ArrowRight size={18} className="ml-1" />
        </Button>
      </div>
    </div>
  );
}
